<template>
  <div class="">
    <div @click="showDownload">
      <img style="height: auto; width: 100%"
           src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/banner/aboutus_banner@2x.png">
    </div>
    <div class="aboutUs">
      <div class="title">邀工网</div>
      <div class="text">
        邀工网是由江苏易用科技有限公司开发的一款结合行业痛点及行业的数据，旨在建设互联网智慧劳务用工平台，建立建筑工人找工作、建筑企业招工人的科学用工生态体系的一款互联网与劳务结合的产品。
      </div>
      <div class="text">
        江苏易用科技有限公司成立于2017年6月，公司位于苏州市相城区清华大学苏州汽车研究院，是一家从事工程及计算机信息科技领域内的软件研发与销售、技术转让、技术咨询、技术服务，以及建筑业大数据应用的科技型企业。
      </div>
      <div class="text">
        江苏易用科技有限公司专注于建筑及相关行业信息技术的研发和应用，主营业务涉及项目管理信息化、智慧工地、智慧安监、BIM技术应用、办公信息化等多个领域。公司秉持“”的核心理念，以“实用创新、踏实研发、高效服务、诚信合作”为发展方向。
      </div>
      <div class="title">产品优势</div>

      <div class="product-advantages">
        <div class="advantages">
          <el-image
            src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/guanyuwomen_youshi_1@2x.png"></el-image>
          <div class="advantages-info">招工、找活一键完成</div>
        </div>
        <div class="advantages">
          <el-image
            src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/guanyuwomen_youshi_2@2x.png"></el-image>
          <div class="advantages-info">“实名制＋信用评价” <br>构建可靠平台</div>
        </div>
        <div class="advantages">
          <el-image
            src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/guanyuwomen_youshi_3@2x.png"></el-image>
          <div class="advantages-info">大数据＋人工智能， <br>优化建筑业人力资源配置</div>
        </div>
        <div class="advantages">
          <el-image
            src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/guanyuwomen_youshi_4@2x.png"></el-image>
          <div class="advantages-info">“线上＋线下”<br> 服务功能更强</div>
        </div>
        <div class="advantages">
          <el-image
            src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/guanyuwomen_youshi_5@2x.png"></el-image>
          <div class="advantages-info">助力培育<br> 新时代建筑产业工人</div>
        </div>
      </div>

      <div class="title">产品下载</div>

      <el-row :gutter="10">
        <el-col :span="12">
          <div class="product-download">
            <div class="download">
              <div class="download-info">
                <div style="font-size: 30px; font-weight: bold;padding-bottom: 10px">APP端</div>
                <div style="padding: 5px 0">免费下载 快速找工作</div>
                <div style="color: #096CEFFF">平台好礼天天送</div>
              </div>
            </div>
            <div class="download" style="text-align: right">
              <el-image class="download-img"
                        src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/QRCode/app.png"></el-image>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="product-download">
            <div class="download">
              <div class="download-info">
                <div style="font-size: 30px; font-weight: bold;padding-bottom: 10px">微信小程序</div>
                <div style="padding: 5px 0">微信扫码打开小程序</div>
                <div style="color: #096CEFFF">招工找活更快捷</div>
              </div>
            </div>
            <div class="download" style="text-align: right">
              <el-image class="download-img"
                        src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/QRCode/xiaochengxu.jpg"></el-image>
            </div>
          </div>
        </el-col>
      </el-row>

      <div class="title">荣誉资质</div>

      <el-row :gutter="10" class="img-1">
        <el-col :span="12">
          <el-image
            src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/aboutus_honor_1@2x.png"></el-image>
        </el-col>
        <el-col :span="12">
          <el-col :span="12">
            <el-image
              src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/aboutus_honor_2@2x.png"></el-image>
          </el-col>
          <el-col :span="12">
            <el-image
              src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/aboutus_honor_3@2x.png"></el-image>
          </el-col>
        </el-col>
      </el-row>

      <el-row :gutter="10" class="img-2">
        <el-col :span="6">
          <el-image
            src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/aboutus_honor_4@2x.png"></el-image>
        </el-col>
        <el-col :span="6">
          <el-image
            src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/aboutus_honor_5@2x.png"></el-image>
        </el-col>
        <el-col :span="6">
          <el-image
            src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/aboutus_honor_6@2x.png"></el-image>
        </el-col>
        <el-col :span="6">
          <el-image
            src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/aboutus_honor_7@2x.png"></el-image>
        </el-col>
      </el-row>

      <div class="title">联系我们</div>

      <el-row class="address">
        <el-col :span="8">
          <img class="logo_footer"
               src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/logo_footer1.png">
          <div class="info-div"><i class="el-icon-edit"></i> 江苏省苏州市相城区太阳路2266号</div>
          <div class="info-div"><i class="el-icon-share"></i> 400-0900-190</div>
          <div class="info-div"><i class="el-icon-message"></i> eyongtech@163.com</div>
          <div class="info-div"><i class="el-icon-position"></i> www.yaogongwang.com</div>
        </el-col>
        <el-col :span="16">
          <div>
            <div style="width:100%;height:280px;border:#ccc solid 1px;" id="dituContent"></div>
          </div>
        </el-col>
      </el-row>

      <download v-if="downloadShow" :type="1" @close="closeDownload"></download>
    </div>
  </div>
</template>

<script>

import download from "@views/components/download";
/* eslint-disable */
// 标注点数组
const markerArr = [{
  title: "江苏易用科技有限公司",
  content: "电话：400-0900-190&nbsp;&nbsp;&nbsp;<br/><br/>邮箱：eyongtech@163.com",
  point: "120.637109|31.417852",
  isOpen: 0,
  icon: {w: 23, h: 25, l: 46, t: 21, x: 9, lb: 12}
}
]
export default {
  name: 'contactUs',
  components: {
    download
  },
  data() {
    return {
      downloadShow: false,
    }
  },
  mounted() {
    this.createMap();//创建地图
    this.setMapEvent();//设置地图事件
    this.addMapControl();//向地图添加控件
    this.addMarker();//向地图中添加marker
  },
  methods: {

    // 弹出登录
    showDownload() {
      this.downloadShow = true
    },

    closeDownload() {
      this.downloadShow = false
    },

    // 初始化地图
    createMap() {
      var map = new BMap.Map("dituContent");//在百度地图容器中创建一个地图
      var point = new BMap.Point(120.637109, 31.417852);//定义一个中心点坐标
      map.centerAndZoom(point, 17);//设定地图的中心点和坐标并将地图显示在地图容器中
      window.map = map;//将map变量存储在全局
    },
    // 地图事件设置函数：
    setMapEvent() {
      map.enableDragging();//启用地图拖拽事件，默认启用(可不写)
      map.enableScrollWheelZoom();//启用地图滚轮放大缩小
      map.enableDoubleClickZoom();//启用鼠标双击放大，默认启用(可不写)
      map.enableKeyboard();//启用键盘上下左右键移动地图
    },
    addMapControl() {
      //向地图中添加缩放控件
      var ctrl_nav = new BMap.NavigationControl({anchor: BMAP_ANCHOR_TOP_LEFT, type: BMAP_NAVIGATION_CONTROL_LARGE});
      map.addControl(ctrl_nav);
      //向地图中添加缩略图控件
      var ctrl_ove = new BMap.OverviewMapControl({anchor: BMAP_ANCHOR_BOTTOM_RIGHT, isOpen: 1});
      map.addControl(ctrl_ove);
      //向地图中添加比例尺控件
      var ctrl_sca = new BMap.ScaleControl({anchor: BMAP_ANCHOR_BOTTOM_LEFT});
      map.addControl(ctrl_sca);
    },
    addMarker() {
      let that = this
      for (var i = 0; i < markerArr.length; i++) {
        var json = markerArr[i];
        var p0 = json.point.split("|")[0];
        var p1 = json.point.split("|")[1];
        var point = new BMap.Point(p0, p1);
        var iconImg = this.createIcon(json.icon);
        var marker = new BMap.Marker(point, {icon: iconImg});
        var iw = this.createInfoWindow(i);
        var label = new BMap.Label(json.title, {"offset": new BMap.Size(json.icon.lb - json.icon.x + 10, -20)});
        marker.setLabel(label);
        map.addOverlay(marker);
        label.setStyle({
          borderColor: "#808080",
          color: "#333",
          cursor: "pointer"
        });

        (function () {
          var index = i;
          var _iw = that.createInfoWindow(i);
          var _marker = marker;
          _marker.addEventListener("click", function () {
            this.openInfoWindow(_iw);
          });
          _iw.addEventListener("open", function () {
            _marker.getLabel().hide();
          })
          _iw.addEventListener("close", function () {
            _marker.getLabel().show();
          })
          label.addEventListener("click", function () {
            _marker.openInfoWindow(_iw);
          })
          if (!!json.isOpen) {
            label.hide();
            _marker.openInfoWindow(_iw);
          }
        })()
      }
    },
    createInfoWindow(i) {
      var json = markerArr[i];
      var iw = new BMap.InfoWindow("<b class='iw_poi_title' title='" + json.title + "'>" + json.title + "</b><div class='iw_poi_content'>" + json.content + "</div>");
      return iw;
    },
    createIcon(json) {
      var icon = new BMap.Icon("http://api.map.baidu.com/lbsapi/creatmap/images/us_mk_icon.png", new BMap.Size(json.w, json.h), {
        imageOffset: new BMap.Size(-json.l, -json.t),
        infoWindowOffset: new BMap.Size(json.lb + 5, 1),
        offset: new BMap.Size(json.x, json.h)
      })
      return icon;
    }
  }
}
</script>

<style scoped lang="scss">

.el-icon-edit {
  background: url('http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/aboutus_icon_address@2x.png') center center no-repeat;
  background-size: 20px;
}

.el-icon-edit:before {
  visibility: hidden;
}

.el-icon-share {
  background: url('http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/aboutus_icon_phone.png') center center no-repeat;
  background-size: 20px;
}

.el-icon-share:before {
  visibility: hidden;
}

.el-icon-message {
  background: url('http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/aboutus_icon_email.png') center center no-repeat;
  background-size: 20px;
}

.el-icon-message:before {
  visibility: hidden;
}

.el-icon-position {
  background: url('http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/aboutUs/aboutus_icon_web.png') center center no-repeat;
  background-size: 20px;
}

.el-icon-position:before {
  visibility: hidden;
}

.aboutUs {
  margin: auto;
  width: 1200px;
  background: #F9F9F9;
  -webkit-box-shadow: 0px 0px 20px #F9F9F9;
  box-shadow: 0px 0px 20px #F9F9F9;
  margin-bottom: 60px;

  .title {
    text-align: center;
    color: #333333;
    font-size: 24px;
    font-weight: bold;
    margin: 24px 0;
  }

  .text {
    text-indent: 2em;
    margin-bottom: 20px;
    color: #333333;
    line-height: 24px;
    font-size: 16px;
  }

  .product-advantages {
    display: flex;

    .advantages {
      margin: 0 5px;
      padding: 35px 15px 30px 15px;
      background: #FFFFFF;
      border-radius: 5px;
      text-align: center;
      width: 100%;

      //noinspection CssInvalidPseudoSelector
      ::v-deep .el-image__inner {
        width: 50px !important;
        height: 50px !important;
      }
    }

    .advantages-info {
      padding-top: 30px;
    }
  }

  .product-download {
    border-radius: 6px;
    display: flex;
    background: #FFFFFF;
    padding: 25px 64px 22px 30px;

    .download {
      text-align: center;
      width: 100%;
      margin: auto;
    }

    .download-info {
      //padding-left: 10px;
      font-size: 20px;
    }

    .download-img {
      height: 120px;
      width: 120px;
    }
  }

  .img-1 {
    //noinspection CssInvalidPseudoSelector
    ::v-deep .el-image {
      width: 100% !important;
      height: 180px !important;
    }
  }

  .img-2 {
    margin-top: 10px;
    //noinspection CssInvalidPseudoSelector
    ::v-deep .el-image {
      width: 100% !important;
      height: 400px !important;
    }
  }

  .address {
    background: #FFFFFF;
    padding: 20px 20px 20px 40px;

    .logo_footer {
      margin-top: 30px;
      width: 170px;
      height: 60px;
    }

    .info-div {
      padding: 10px 0;
      padding-left: 5px;

      i {
        font-size: 20px;
      }
    }
  }

}
</style>
